import { buildQueries } from "@testing-library/dom"
import landingpage from "./landingpage.module.css"
import { use, useState } from "react"
import { AddtoCart } from "../items/AddtoCart"
import { useDispatch, useSelector } from "react-redux"
import { useParams } from "react-router-dom/dist"
import { itemdesc } from "./itemdesc"

export function LandingPage(props){
    const {item} = useParams()
    console.log(item)
    console.log("logged from landingpage")
    const [quantity, setQuantity] = useState(1)
    const [imageSelected, setImageSelected] = useState(1)
    const dispatch = useDispatch()
    const inventory = useSelector(state => state.inventory)
    let bagObject
    inventory.forEach(inventoryItem => {
        if (inventoryItem.name === item){
            bagObject = inventoryItem
        }
    })
    let shippingHeight = 0
    const updateQuantity = (newQuantity) => {
        if (quantity + newQuantity >= 1){
        setQuantity(quantity + newQuantity)
        }
    }

    const setBigImage = (num) => {
        setImageSelected(num)
    }

    const imagesDisplay = itemdesc[item].images.map((image, index) => {
        return <img src= {image} style={{border: imageSelected === (index + 1) ? "2px solid blue" : "none"}} onClick={() => setBigImage(index + 1)}/>
    })

    const dropdowns = itemdesc[item].dropdowns.map((dropdown, index) => {
        const dropdownId = `${landingpage.dropdown}${index + 1}`;
     return (
        <div>
        <input type="checkbox" id={dropdownId} className={landingpage.featuresInput}></input>
        <label for={dropdownId}>
        <div class={landingpage.dropdown}>
            <div className={landingpage.clicktoDropdown}> <div>{dropdown.title}</div>     <div class={landingpage.plusSign} onclick="togglePlusMinus(this)">
                                      <span class={landingpage.horizontal}></span>
                                      <span class={landingpage.vertical}></span>  </div> </div>
            <p>{dropdown.text}</p>
        </div>
        </label>
        </div>
     )
   })

    return (
        <div>
        <div className={landingpage.overallWrapper}>

        <div className={landingpage.imagesWrapper}>
            <div className={landingpage.bigImageWrapper}>
                <img src= {itemdesc[item].images[imageSelected -1]} />
            </div>
            <div className={landingpage.smallImagesWrapper}>
                {imagesDisplay}
            </div>
        </div>

        <div className={landingpage.infoWrapper}>
        
            <h1>{itemdesc[item].title}</h1>
            <p className={landingpage.price}>£20</p>

            <p className={landingpage.text}>{itemdesc[item].description}</p>
            <div className={landingpage.quantity}><span className={landingpage.remove} onClick={() => updateQuantity(-1)}>-</span> <span>{quantity}</span> <span onClick={() => updateQuantity(1)}>+</span></div>
            <AddtoCart item={bagObject} dispatch={dispatch} quantity={quantity}>
            <button className={landingpage.addtoCart}>Add to Cart</button>
            </AddtoCart>
            <hr/>

        {/*  Dropdown Features  */}
        <div className={landingpage.dropdownInfo}>
            {/*  Features Popup */}
            {dropdowns}
            {/*
                        <div>
            <input type="checkbox" id={landingpage.dropdown1} className={landingpage.featuresInput}></input>
            <label for={landingpage.dropdown1}>
            <div class={landingpage.dropdown}>
                <div className={landingpage.clicktoDropdown}> <div>Care</div>     <div class={landingpage.plusSign} onclick="togglePlusMinus(this)">
                                          <span class={landingpage.horizontal}></span>
                                          <span class={landingpage.vertical}></span>  </div> </div>
                <p>some more info... you are welcome 1</p>
            </div>
            </label>
            </div>

           
            <div>
            <input type="checkbox" id={landingpage.dropdown2} className={landingpage.featuresInput}></input>
            <label for={landingpage.dropdown2}>
            <div class={landingpage.dropdown}>

                <div className={landingpage.clicktoDropdown}> <div>Care</div>     <div class={landingpage.plusSign} onclick="togglePlusMinus(this)">
                                          <span class={landingpage.horizontal}></span>
                                          <span class={landingpage.vertical}></span>  </div> </div>
                <p>some more info... you are welcome 1</p>
            </div>
            </label>
            </div>

            
        
            <div>
            <input type="checkbox" id={landingpage.dropdown3} className={landingpage.featuresInput}></input>
            <label for={landingpage.dropdown3}>
            <div class={landingpage.dropdown}>
            <div className={landingpage.clicktoDropdown}> <div>Shipping</div>     <div class={landingpage.plusSign} onclick="togglePlusMinus(this)">
                                          <span class={landingpage.horizontal}></span>
                                          <span class={landingpage.vertical}></span>  </div> </div>
                <p>Free Shipping on all Orders!</p>
            </div>
            </label>
            </div> 
            */}
        </div>
        </div>
        </div>


        
        </div>
    )
}